import React from "react";
import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";

/**
 * Groups enhancement (GRP-DEC-314) — navigation from an authorized Group management
 * surface to the person's EXISTING Startup Otter personal profile at the canonical
 * `/p/{slug}` route. There is no Group-specific member profile, and nothing private to the
 * Group (membership answers above all) travels with the link.
 *
 * `person` is the card the Groups APIs already return: {display_name, slug, headshot_url}.
 * With no slug there is nothing to link to, so the name renders as plain text rather than
 * a dead link.
 */
export function PersonLink({ person, testId, subtitle = null, size = 36 }) {
  const name = person?.display_name || "Member";
  const slug = person?.slug;
  const avatar = person?.headshot_url;
  const box = { width: size, height: size };

  const face = (
    <span className="flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-secondary text-xs font-[640] text-muted-foreground"
          style={box} aria-hidden="true">
      {avatar ? <img src={fileUrl(avatar)} alt="" className="h-full w-full object-cover" />
        : name.slice(0, 1).toUpperCase()}
    </span>
  );

  const body = (
    <>
      {face}
      <span className="min-w-0">
        <span className="block truncate font-medium">{name}</span>
        {subtitle ? (
          <span className="block truncate text-xs text-muted-foreground">{subtitle}</span>
        ) : null}
      </span>
    </>
  );

  if (!slug) {
    return <span className="flex items-center gap-2" data-testid={testId}>{body}</span>;
  }
  return (
    <Link to={`/p/${slug}`} data-testid={testId}
          aria-label={`View ${name}'s profile`}
          className="flex items-center gap-2 rounded-md transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
      {body}
    </Link>
  );
}
